module.exports = __webpack_public_path__ + "static_for_front/img/authorization-background.ec620eb4.jpg";